<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="active"
    >
      <v-tab
        v-for="item in tabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <div
      v-if="loading"
      align="center" 
      justify="center"
    >
      <v-progress-linear
        indeterminate
        color="primary"
      />
    </div> 
    <div v-else>
      <v-tabs-items
        v-model="active"
        style="background:transparent"
      >
        <v-tab-item>
          <v-autocomplete
            v-model="employeeELetter"
            label="E Letter Types"
            :items="employeeELetterTypes"
            item-text="name"
            class="pt-5 px-3"
            autofocus
            style="background:white"
          />
          <payroll-e-letter-download-letter
            v-if="employeeELetter"
            :letter-type="employeeELetter"
            :years="years"
            :companies="companies"
            class="mb-2"
          />
        </v-tab-item>
        <v-tab-item>
          <employee-e-letter-card-list-employee-position
            :companies="companies"
            :letter-types="employeeELetterTypes"
            class="mb-2"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
      PayrollELetterDownloadLetter: () => import('@/components/hris/payroll/e-letter/DownloadLetterCard'),
      EmployeeELetterCardListEmployeePosition: () => import('@/components/hris/employee/e-letter/CardListEmployeePosition'),
    },

    data () {
      return {
        tabItems: [
          { name: 'E Letters' },
          { name: 'Release E Letters' },
        ],
        active: 0,
        loading: false,
        years: [],
        companies: [],
        employeeELetter: null,
        employeeELetterTypes: [
          { name: 'Position Restructuring Letters' },
        ],
        appOrg: process.env.VUE_APP_ORG,
      }
    },
    created () {
      this.loading = true

      Promise.all([
        this.$api.hrisEmployeePositions().listYears(),
        this.$api.hrisCompanies().list('?organization=' + this.appOrg),
      ])
        .then(([years, companies]) => {
          this.years = years.data

          this.companies = _.orderBy(companies.data, ['name'], ['asc'])
          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.loading = false
        })
    },
  }
</script>
